import React from 'react';

import { Wrapper } from './styles';

export type ButtonStyleType =
  | 'OK'
  | 'Warning'
  | 'Confirm'
  | 'Light'
  | 'Dark'
  | 'Transparent'
  | 'Secondary';

export interface Props {
  text: string;
  type?: 'button' | 'submit' | 'reset' | undefined;
  handleClick?: (arg?: any) => void;
  disabled?: boolean;
  width?: string;
  height?: string;
  style?: React.CSSProperties;
  styleType?: ButtonStyleType;
}

const Button: React.FunctionComponent<Props> = ({
  text,
  type,
  handleClick,
  disabled = false,
  width = '100%',
  height = '56px',
  styleType,
  style,
}) => {
  let bg = 'var(--colorWhite)';
  let textColor = 'var(--colorBlueGray1200)';
  let borderColor = 'transparent';
  let hoverBg = 'var(--colorBlueGray1200)';
  let hoverTextColor = 'var(--colorWhite)';

  switch (styleType) {
    case 'Confirm':
      bg = disabled
        ? 'var(--colorBlueGray100)'
        : 'linear-gradient(-180deg, rgb(32, 153, 70) 0%, rgb(23, 132, 69) 100%)';
      textColor = disabled ? 'var(--colorBlueGray600)' : 'var(--colorWhite)';
      hoverBg = disabled
        ? 'var(--colorBlueGray100)'
        : 'linear-gradient(0deg, rgba(0, 0, 0, 0.08), rgba(0, 0, 0, 0.08)), linear-gradient(180deg, #209946 0%, #178445 100%);';
      hoverTextColor = disabled ? 'var(--colorBlueGray600)' : 'var(--colorWhite)';
      break;

    case 'Warning':
      bg = disabled
        ? 'var(--colorBlueGray100)'
        : 'linear-gradient(180deg, #E3273B 0.05%, #AD2331 100%)';
      textColor = disabled ? 'var(--colorBlueGray600)' : 'var(--colorWhite)';
      hoverBg = disabled
        ? 'var(--colorBlueGray100)'
        : 'linear-gradient(180deg, #E3273B 0.05%, #AD2331 70%)';
      hoverTextColor = disabled ? 'var(--colorBlueGray600)' : 'var(--colorWhite)';
      break;

    case 'OK':
      bg = disabled
        ? 'var(--colorBlueGray100)'
        : 'linear-gradient(180deg, #1642BE 0.69%, #173792 100%)';
      textColor = disabled ? 'var(--colorBlueGray600)' : 'var(--colorWhite)';
      hoverBg = disabled
        ? 'var(--colorBlueGray100)'
        : 'linear-gradient(0deg, rgba(0, 0, 0, 0.08), rgba(0, 0, 0, 0.08)), linear-gradient(180deg, #1642BE 0.69%, #173792 100%)';
      hoverTextColor = disabled ? 'var(--colorBlueGray600)' : 'var(--colorWhite)';
      break;

    case 'Secondary':
      bg = 'transparent';
      textColor = '#1642BE';
      hoverBg = 'var(--colorBlueGray100)';
      borderColor = '#1642BE';
      hoverTextColor = '#1642BE';
      break;

    case 'Dark':
      bg = 'linear-gradient(180deg, #41474F 0.05%, #1C232C 100%);';
      textColor = 'var(--colorWhite)';
      hoverBg = 'linear-gradient(180deg, #8B8F93 0.05%, #666B71 100%);';
      hoverTextColor = 'var(--colorWhite)';
      break;

    case 'Transparent':
      bg = 'transparent';
      borderColor = 'var(--colorBlueGray800)';
      hoverBg = 'var(--colorWhite)';
      hoverTextColor = 'var(--colorBlueGray1200)';
      break;

    default:
      break;
  }

  return (
    <Wrapper
      type={type}
      onClick={!disabled ? handleClick : undefined}
      width={width}
      minHeight={height}
      bg={bg}
      textColor={textColor}
      borderColor={borderColor}
      hoverBg={hoverBg}
      hoverTextColor={hoverTextColor}
      disabled={disabled}
      style={style}>
      <span>{text}</span>
    </Wrapper>
  );
};

export default Button;
